import {
  SOURCES_MODULE_NAME,
  LIST_STATE_NAME,
  REDIRECTING_TO_STATE_NAME,
  LOADER_STATE_NAME,
} from './constants';

const sourcesInitialState = {
  [SOURCES_MODULE_NAME]: {
    [LIST_STATE_NAME]: {
      isFetching: false,
      error: null,
      data: [],
    },
    [REDIRECTING_TO_STATE_NAME]: {
      isShow: false,
      count: 0,
      redirectUrl: '',
      publishYourCv: null,
    },
    [LOADER_STATE_NAME]: {
      isShow: false,
    },
  },
};

export default sourcesInitialState;



// WEBPACK FOOTER //
// ./app/Sources/initialState.js